let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fmu7u")).then(() => parcelRequire('3TLH8'));